<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="投放计划id" prop="scheduleId">
          <el-input v-model="dataForm.scheduleId" placeholder="投放计划id"></el-input>
      </el-form-item>
          <el-form-item label="投放时间" prop="dates">
          <el-input v-model="dataForm.dates" placeholder="投放时间"></el-input>
      </el-form-item>
          <el-form-item label="周期(例:星期一)" prop="cycle">
          <el-input v-model="dataForm.cycle" placeholder="周期(例:星期一)"></el-input>
      </el-form-item>
          <el-form-item label="周期值(例:1)" prop="cycleValue">
          <el-input v-model="dataForm.cycleValue" placeholder="周期值(例:1)"></el-input>
      </el-form-item>
          <el-form-item label="time0" prop="time0">
          <el-input v-model="dataForm.time0" placeholder="time0"></el-input>
      </el-form-item>
          <el-form-item label="time1" prop="time1">
          <el-input v-model="dataForm.time1" placeholder="time1"></el-input>
      </el-form-item>
          <el-form-item label="time2" prop="time2">
          <el-input v-model="dataForm.time2" placeholder="time2"></el-input>
      </el-form-item>
          <el-form-item label="time3" prop="time3">
          <el-input v-model="dataForm.time3" placeholder="time3"></el-input>
      </el-form-item>
          <el-form-item label="time4" prop="time4">
          <el-input v-model="dataForm.time4" placeholder="time4"></el-input>
      </el-form-item>
          <el-form-item label="time5" prop="time5">
          <el-input v-model="dataForm.time5" placeholder="time5"></el-input>
      </el-form-item>
          <el-form-item label="time6" prop="time6">
          <el-input v-model="dataForm.time6" placeholder="time6"></el-input>
      </el-form-item>
          <el-form-item label="time7" prop="time7">
          <el-input v-model="dataForm.time7" placeholder="time7"></el-input>
      </el-form-item>
          <el-form-item label="time8" prop="time8">
          <el-input v-model="dataForm.time8" placeholder="time8"></el-input>
      </el-form-item>
          <el-form-item label="time9" prop="time9">
          <el-input v-model="dataForm.time9" placeholder="time9"></el-input>
      </el-form-item>
          <el-form-item label="time10" prop="time10">
          <el-input v-model="dataForm.time10" placeholder="time10"></el-input>
      </el-form-item>
          <el-form-item label="time11" prop="time11">
          <el-input v-model="dataForm.time11" placeholder="time11"></el-input>
      </el-form-item>
          <el-form-item label="time12" prop="time12">
          <el-input v-model="dataForm.time12" placeholder="time12"></el-input>
      </el-form-item>
          <el-form-item label="time13" prop="time13">
          <el-input v-model="dataForm.time13" placeholder="time13"></el-input>
      </el-form-item>
          <el-form-item label="time14" prop="time14">
          <el-input v-model="dataForm.time14" placeholder="time14"></el-input>
      </el-form-item>
          <el-form-item label="time15" prop="time15">
          <el-input v-model="dataForm.time15" placeholder="time15"></el-input>
      </el-form-item>
          <el-form-item label="time16" prop="time16">
          <el-input v-model="dataForm.time16" placeholder="time16"></el-input>
      </el-form-item>
          <el-form-item label="time17" prop="time17">
          <el-input v-model="dataForm.time17" placeholder="time17"></el-input>
      </el-form-item>
          <el-form-item label="time18" prop="time18">
          <el-input v-model="dataForm.time18" placeholder="time18"></el-input>
      </el-form-item>
          <el-form-item label="time19" prop="time19">
          <el-input v-model="dataForm.time19" placeholder="time19"></el-input>
      </el-form-item>
          <el-form-item label="time20" prop="time20">
          <el-input v-model="dataForm.time20" placeholder="time20"></el-input>
      </el-form-item>
          <el-form-item label="time21" prop="time21">
          <el-input v-model="dataForm.time21" placeholder="time21"></el-input>
      </el-form-item>
          <el-form-item label="time22" prop="time22">
          <el-input v-model="dataForm.time22" placeholder="time22"></el-input>
      </el-form-item>
          <el-form-item label="time23" prop="time23">
          <el-input v-model="dataForm.time23" placeholder="time23"></el-input>
      </el-form-item>
          <el-form-item label="time24" prop="time24">
          <el-input v-model="dataForm.time24" placeholder="time24"></el-input>
      </el-form-item>
          <el-form-item label="time25" prop="time25">
          <el-input v-model="dataForm.time25" placeholder="time25"></el-input>
      </el-form-item>
          <el-form-item label="time26" prop="time26">
          <el-input v-model="dataForm.time26" placeholder="time26"></el-input>
      </el-form-item>
          <el-form-item label="time27" prop="time27">
          <el-input v-model="dataForm.time27" placeholder="time27"></el-input>
      </el-form-item>
          <el-form-item label="time28" prop="time28">
          <el-input v-model="dataForm.time28" placeholder="time28"></el-input>
      </el-form-item>
          <el-form-item label="time29" prop="time29">
          <el-input v-model="dataForm.time29" placeholder="time29"></el-input>
      </el-form-item>
          <el-form-item label="time30" prop="time30">
          <el-input v-model="dataForm.time30" placeholder="time30"></el-input>
      </el-form-item>
          <el-form-item label="time31" prop="time31">
          <el-input v-model="dataForm.time31" placeholder="time31"></el-input>
      </el-form-item>
          <el-form-item label="time32" prop="time32">
          <el-input v-model="dataForm.time32" placeholder="time32"></el-input>
      </el-form-item>
          <el-form-item label="time33" prop="time33">
          <el-input v-model="dataForm.time33" placeholder="time33"></el-input>
      </el-form-item>
          <el-form-item label="time34" prop="time34">
          <el-input v-model="dataForm.time34" placeholder="time34"></el-input>
      </el-form-item>
          <el-form-item label="time35" prop="time35">
          <el-input v-model="dataForm.time35" placeholder="time35"></el-input>
      </el-form-item>
          <el-form-item label="time36" prop="time36">
          <el-input v-model="dataForm.time36" placeholder="time36"></el-input>
      </el-form-item>
          <el-form-item label="time37" prop="time37">
          <el-input v-model="dataForm.time37" placeholder="time37"></el-input>
      </el-form-item>
          <el-form-item label="time38" prop="time38">
          <el-input v-model="dataForm.time38" placeholder="time38"></el-input>
      </el-form-item>
          <el-form-item label="time39" prop="time39">
          <el-input v-model="dataForm.time39" placeholder="time39"></el-input>
      </el-form-item>
          <el-form-item label="time40" prop="time40">
          <el-input v-model="dataForm.time40" placeholder="time40"></el-input>
      </el-form-item>
          <el-form-item label="time41" prop="time41">
          <el-input v-model="dataForm.time41" placeholder="time41"></el-input>
      </el-form-item>
          <el-form-item label="time42" prop="time42">
          <el-input v-model="dataForm.time42" placeholder="time42"></el-input>
      </el-form-item>
          <el-form-item label="time43" prop="time43">
          <el-input v-model="dataForm.time43" placeholder="time43"></el-input>
      </el-form-item>
          <el-form-item label="time44" prop="time44">
          <el-input v-model="dataForm.time44" placeholder="time44"></el-input>
      </el-form-item>
          <el-form-item label="time45" prop="time45">
          <el-input v-model="dataForm.time45" placeholder="time45"></el-input>
      </el-form-item>
          <el-form-item label="time46" prop="time46">
          <el-input v-model="dataForm.time46" placeholder="time46"></el-input>
      </el-form-item>
          <el-form-item label="time47" prop="time47">
          <el-input v-model="dataForm.time47" placeholder="time47"></el-input>
      </el-form-item>
          <el-form-item label="是否已生效(1已生效,0未生效)" prop="finalStatus">
          <el-input v-model="dataForm.finalStatus" placeholder="是否已生效(1已生效,0未生效)"></el-input>
      </el-form-item>
          <el-form-item label="状态" prop="status">
          <el-input v-model="dataForm.status" placeholder="状态"></el-input>
      </el-form-item>
          <el-form-item label="备注" prop="remark">
          <el-input v-model="dataForm.remark" placeholder="备注"></el-input>
      </el-form-item>
              <el-form-item label="更新者" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新者"></el-input>
      </el-form-item>
          <el-form-item label="更新时间" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新时间"></el-input>
      </el-form-item>
          <el-form-item label="删除者" prop="deleteBy">
          <el-input v-model="dataForm.deleteBy" placeholder="删除者"></el-input>
      </el-form-item>
          <el-form-item label="删除时间" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除时间"></el-input>
      </el-form-item>
          <el-form-item label="线索数量" prop="quantity">
          <el-input v-model="dataForm.quantity" placeholder="线索数量"></el-input>
      </el-form-item>
          <el-form-item label="详细时间段" prop="detailedTime">
          <el-input v-model="dataForm.detailedTime" placeholder="详细时间段"></el-input>
      </el-form-item>
          <el-form-item label="锁定线索数量" prop="lockThread">
          <el-input v-model="dataForm.lockThread" placeholder="锁定线索数量"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        scheduleId: '',
        dates: '',
        cycle: '',
        cycleValue: '',
        time0: '',
        time1: '',
        time2: '',
        time3: '',
        time4: '',
        time5: '',
        time6: '',
        time7: '',
        time8: '',
        time9: '',
        time10: '',
        time11: '',
        time12: '',
        time13: '',
        time14: '',
        time15: '',
        time16: '',
        time17: '',
        time18: '',
        time19: '',
        time20: '',
        time21: '',
        time22: '',
        time23: '',
        time24: '',
        time25: '',
        time26: '',
        time27: '',
        time28: '',
        time29: '',
        time30: '',
        time31: '',
        time32: '',
        time33: '',
        time34: '',
        time35: '',
        time36: '',
        time37: '',
        time38: '',
        time39: '',
        time40: '',
        time41: '',
        time42: '',
        time43: '',
        time44: '',
        time45: '',
        time46: '',
        time47: '',
        finalStatus: '',
        status: '',
        remark: '',
        creator: '',
        createDate: '',
        updateBy: '',
        updateTime: '',
        deleteBy: '',
        deleteTime: '',
        quantity: '',
        detailedTime: '',
        lockThread: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        scheduleId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dates: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cycle: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cycleValue: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time0: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time1: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time2: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time3: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time4: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time5: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time6: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time7: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time8: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time9: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time10: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time11: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time12: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time13: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time14: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time15: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time16: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time17: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time18: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time19: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time20: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time21: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time22: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time23: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time24: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time25: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time26: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time27: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time28: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time29: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time30: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time31: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time32: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time33: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time34: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time35: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time36: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time37: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time38: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time39: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time40: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time41: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time42: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time43: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time44: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time45: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time46: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        time47: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        finalStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        quantity: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        detailedTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        lockThread: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tscheduledetail/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tscheduledetail/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
